import React from 'react';
import styled from 'styled-components';

const HeroSection = styled.section`
  background: linear-gradient(135deg, #f0f7fb 0%, #ffffff 100%);
  position: relative;
  overflow: hidden;
  padding: 100px 5% 120px;
`;

const HeroContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1100px; /* Tighter layout */
  margin: 0 auto;
  position: relative;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const TextContent = styled.div`
  max-width: 520px;
  z-index: 2;

  @media (max-width: 900px) {
    margin-bottom: 60px;
    text-align: center;
  }
`;

const Title = styled.h1`
  font-family: 'Open Sans', sans-serif;
  font-size: 52px;
  font-weight: 800;
  color: #1a2a3a; /* Darker contrast */
  line-height: 1.15;
  margin-bottom: 24px;

  @media (max-width: 900px) {
    font-size: 38px;
  }
`;

const Subtitle = styled.p`
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  color: #4a5568; /* Better contrast */
  line-height: 1.6;
  margin-bottom: 40px;
  font-weight: 500;
`;

const CtaButton = styled.a`
  display: inline-block;
  background: #25aae3;
  color: #fff;
  border: none;
  padding: 18px 36px;
  border-radius: 4px;
  font-size: 16px;
  font-family: 'Montserrat', sans-serif;
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 6px 15px rgba(37, 170, 227, 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    background: #1c94c9;
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(37, 170, 227, 0.6);
  }
`;

const ImageContainer = styled.div`
  z-index: 2;
  width: 580px; /* Bigger hero image */
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 900px) {
    width: 100%;
    max-width: 480px;
  }
`;

const PhoneMockup = styled.img`
  width: 100%;
  height: auto;
  transform: rotate(8deg) scale(1.02);
  filter: drop-shadow(-15px 25px 35px rgba(0,0,0,0.2));
  transition: transform 0.6s ease;

  &:hover {
    transform: rotate(2deg) scale(1.05);
  }

  @media (max-width: 900px) {
    transform: rotate(0deg) scale(1);
  }
`;

const BackgroundSlant = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 55%;
  height: 120%;
  background: #e1eff6;
  z-index: 1;
  transform: skewX(-15deg) translateX(20%);

  @media (max-width: 900px) {
    display: none;
  }
`;

const Hero = () => {
  return (
    <HeroSection id="home">
      <BackgroundSlant />
      <HeroContainer>
        <TextContent>
          <Title>Gain Thousands of REAL Instagram Followers Every Month</Title>
          <Subtitle>
            Using the power of automation, we've developed a safe way to passively gain followers through automated social interactions, all from the comfort of your computer.
          </Subtitle>
          <CtaButton href="#pricing">GET STARTED TODAY</CtaButton>
        </TextContent>
        <ImageContainer>
          <PhoneMockup src="/iPhoneMockup.gif" alt="Gainsta iOS App" />
        </ImageContainer>
      </HeroContainer>
    </HeroSection>
  );
};

export default Hero;
